import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SpeedTestPage from './components/SpeedTestPage';
import LoginPage from './components/layout/LoginPage';
import AdminShell from './components/admin/AdminShell';
import ResultsList from './components/admin/ResultsList';
import AdminUsers from './components/admin/AdminUsers';
import AdminSettings from './components/admin/AdminSettings';
import Submitters from './components/admin/Submitters';
import ToastContainer from './components/layout/ToastContainer';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('speedtest_token');
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <Routes>
        <Route path="/" element={<SpeedTestPage />} />
        <Route path="/admin/login" element={<LoginPage />} />
        <Route path="/admin" element={
          <ProtectedRoute>
            <AdminShell>
              <ResultsList />
            </AdminShell>
          </ProtectedRoute>
        } />
        <Route path="/admin/users" element={
          <ProtectedRoute>
            <AdminShell>
              <AdminUsers />
            </AdminShell>
          </ProtectedRoute>
        } />
        <Route path="/admin/submitters" element={
          <ProtectedRoute>
            <AdminShell>
              <Submitters />
            </AdminShell>
          </ProtectedRoute>
        } />
        <Route path="/admin/settings" element={
          <ProtectedRoute>
            <AdminShell>
              <AdminSettings />
            </AdminShell>
          </ProtectedRoute>
        } />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
